module.exports = __webpack_public_path__ + "img/objective-5@2x.85dd3526.jpg";